import enUSMessages from './messages/en_US.json'
import deDEMessages from './messages/de_DE.json'

export const enUS = enUSMessages
export const deDE = deDEMessages
